module.exports = "<ui-view></ui-view>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-sepa/template.html
 ** module id = 432
 ** module chunks = 1
 **/